angular.module('impactx.controlstructure').controller('PSPCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    PSPCtrl
]);

function PSPCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/psp/view";
    $scope.endPointSave = "/control/psp/save";
    $scope.endPointDelete = "/control/psp/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.psp.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.psp.readOnly && !$scope.data.psp.deprecated;
    }
}